/**
 * Health Check Service
 * Simple service to test Firebase Functions connectivity
 */

// Get project ID from environment or fallback to default
const getProjectId = () => {
  return process.env.REACT_APP_FIREBASE_PROJECT_ID || 'burnt-app-62fa7';
};

const getHealthCheckUrl = () => {
  const projectId = getProjectId();
  return `https://us-central1-${projectId}.cloudfunctions.net/healthCheck`;
};

export const healthCheckService = {
  /**
   * Performs a health check by calling the Firebase function
   * @returns {Promise<Object>} Health check response
   */
  async performHealthCheck() {
    try {
      const healthCheckUrl = getHealthCheckUrl();
      console.log('🔍 Health check URL:', healthCheckUrl);
      
      const response = await fetch(healthCheckUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (!response.ok) {
        throw new Error(`Health check failed: ${response.status} ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ Health check successful:', data);
      return {
        success: true,
        data,
        timestamp: new Date().toISOString()
      };
    } catch (error) {
      console.error('❌ Health check failed:', error);
      return {
        success: false,
        error: error.message,
        timestamp: new Date().toISOString()
      };
    }
  },

  /**
   * Performs a silent health check (no console logs)
   * @returns {Promise<boolean>} True if healthy, false otherwise
   */
  async isHealthy() {
    try {
      const healthCheckUrl = getHealthCheckUrl();
      const response = await fetch(healthCheckUrl, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      });
      return response.ok;
    } catch (error) {
      return false;
    }
  }
};

export default healthCheckService;